import DocumentPro from './DocumentPro'

export default DocumentPro
